import apiATS from '../services/apiATS';
import apiNetCore from '../services/apiNetCore';
import { getTarifaTmov } from './clientesShipper';

export const getDadosCalculoFrete = async (endereco, idCliente) => {
  const promises = [
    apiNetCore.get('lotes-integracao/parametros-rota', {
      params: {
        idCidadeOrigem: endereco.idCidadeOrigem,
        idCidadeDestino: endereco.idCidadeDestino,
      },
    }),
  ];

  const promisesResolved = await Promise.all(promises);
  const { icms: valorICMS, pedagio } = promisesResolved[0].data;
  const { tarifaTmovCliente, isPercentualTmov } = await getTarifaTmov(
    idCliente
  );

  return {
    valorICMS,
    tarifaTmovCliente,
    isPercentualTmov,
    pedagioCalculado: (pedagio * 7) / 37,
  };
};

export const getDadosCalculoFreteSeparado = async (
  endereco,
  idClientePagador
) => {
  const promises = [
    apiATS.post('/LoteAts/RotasKmPedagio', {
      idOrigem: endereco.idCidadeOrigem,
      idDestino: endereco.idCidadeDestino,
    }),
    apiATS.get('/AliquotaFreteCalcAts/GetIcms', {
      params: {
        idEstadoOrigem: endereco.idEstadoOrigem,
        idEstadoDestino: endereco.idEstadoDestino,
      },
    }),
  ];
  const promisesResolved = await Promise.all(promises);

  const valorPedagio = promisesResolved[0]?.data?.data?.ValorPedagio;
  const valorICMS = promisesResolved[1]?.data?.data;
  const { isPercentualTmov, tarifaTmovCliente } = await getTarifaTmov(
    idClientePagador
  );

  return {
    valorICMS,
    tarifaTmovCliente,
    isPercentualTmov,
    pedagioCalculado: (valorPedagio * 7) / 37,
  };
};

export const getFaixaTarifaTmov = (
  segmentacao,
  tarifaTmovClienteLista,
  valor,
  isTarifaPercentual
) => {
  let tarifaTmovFaixa;

  if (segmentacao === 'PJ') {
    let faixaTarifaTmov = 0;
    faixaTarifaTmov = tarifaTmovClienteLista?.tarifas
      ? tarifaTmovClienteLista.tarifas
          .filter(
            item => valor >= item.valor_inicial && valor <= item.valor_final
          )
          .pop()
      : 0;

    tarifaTmovFaixa = isTarifaPercentual
      ? faixaTarifaTmov?.valor_tarifa_percentual / 100
      : faixaTarifaTmov?.valor_tarifa_reais_tonelada;
  }
  return tarifaTmovFaixa;
};
